<template>
    <div :class="{hasError:isError}" style="width: 100%;"  v-if="value"> 
         <label>System</label>


        <DataTable :value="value" dataKey="VIPSystem" :disabled="disabled" >
           
            <Column field="IsSelect" header="IsSelect">
                    <template #body="slotProps">
                        <Checkbox v-model="slotProps.data.IsSelect" :binary="true" />          
                    </template>
            </Column>

            <Column field="VIPSystem" header="VIPSystem" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;"></Column>
            
            <Column field="IsAttachment" header="IsAttachment">
                    <template #body="slotProps">
                        <div v-if="slotProps.data.IsAttachment ==true">
                            <my-UploadFile v-model="slotProps.data.Attachment" v-model:error="fileError"></my-UploadFile>
                       </div>
                        <my-DownloadFile v-if="slotProps.data.Attachment.FileName"
                            :filename="slotProps.data.Attachment.FileName"
                            :filecontent="slotProps.data.Attachment.FileContext"
                            ></my-DownloadFile>
                    </template>
            </Column>

          <Column field="FlowStatus" header="FlowStatus" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;">
                <template #body="{ data }">
                <div class="flex align-items-center gap-2">
                    {{ getStatusName(data.FlowStatus) }}
                </div>
                </template>
            </Column>
            <Column field="Reason" header="Reason" bodyStyle="padding: 0rem 1rem;" headerStyle="padding: 0.5rem 1rem;">
                <template #body="{ data }">
                <div class="flex align-items-center gap-2">
                    {{ data.Reason }}
                </div>
                </template>
            </Column>

            
           
         </DataTable>
        
    </div>
</template>  
<script>

import Service from "../../service/service";
export default {
    props: ["modelValue", "supervisorSystem", 'disabled'],
    emits: ["update:modelValue"],
    name: 'SystemSelect',
    components: {

    },
    data() {
        return {
            value: [],
        }
    },
    async created() {
        this.Service = new Service();
        this.value=this.modelValue;
       
    },
    computed: {
      isError() {
            return    this.value.filter(x=>x.IsSelect==true).length==0     ;
    },
    },
    methods: {
        getStatusName(status) {
           
           if(status==0){
                return this.$t("flowStatusName.Processing");    //'簽核中|Processing'
           }
           else if(status==1){
               return this.$t("flowStatusName.Approval");
                //return '同意|Approval'
           }
           else if(status==2){
               return this.$t("flowStatusName.Reject");
                //return '不同意|Reject'
           }
        },
    },
    watch: {
        value: function() {
            this.$emit("update:modelValue", this.value);
        }
    }
}
</script>
  

<style scoped>

.hasError  {
  color:red;
  border-color: red;
  border-width: thin;
  border: 1px solid;
  border-radius: 5px;
}
</style>